export class GuidUtils {

    static readonly EMPTY = "00000000-0000-0000-0000-000000000000";
    /**
     * Skapar en Guid enligt V4-specifikationen
     * @returns En v4-guid
     */
    static newGuid(): string {
        // Fungerar enbart om man kör med HTTPS (window.isSecureContext === true) men det är ett krav sedan länge
        return crypto.randomUUID();
    }
}
